module.exports = __webpack_public_path__ + "img/SeedAppiconWeb.6e97461c.png";